/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useMemo } from 'react';
import LoadingContent from 'components/LoadingContent';
import { useFormik } from 'formik';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import { Container, Form, Spinner, Button, Card } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from 'app/hooks';
// import Cookies from 'js-cookie';
import { useHistory } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
// import { authenticateSettings } from 'components/helper/appConfig';
import SelectInput from 'components/input/SelectInput';
import TextInput from 'components/input/textInput';
import {
  checkEnableParseJSON,
  csuCountry,
  formatBoolean,
  fullSuffixOptions,
  jobCategory,
  occupationOptions,
  optionStringValues,
  // optionValues,
} from 'components/helper/helper';
import SelectPhoneCodeInput from 'components/input/SelectPhoneCodeInput';
import TextIconInput from 'components/input/TextIconInput';
import GroupRadioButton from 'components/input/GroupRadioButton';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import collegeServices from 'services/collegeServices';
import {
  getStepParent1,
  updateStepParent1,
  getStepParent2,
  updateStepParent2,
  getHousehold,
} from 'app/family/familySlice';
import Education from '../parent/components/Education';
import { useLocation } from 'react-router-dom';
import DatePickerInput from 'components/input/DatePicker';
import YesNoSwitch from 'components/input/YesNoSwitch';
import Residency from '../parent/components/Residency';
import { countryOptions } from 'components/helper/countryPhoneCode';
import CheckboxInput from 'components/input/CheckboxInput';
import { debounce, defer } from 'lodash';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import AutocompleteInput from 'components/input/AutoCompleteInput';
import { canadaProvince, usaState } from 'components/helper/stateAndCounty';
import Grid from '@mui/joy/Grid';
import ConditionalGrid from 'components/helper/ConditionalGrid';
// import { ModalCheckField } from 'screen/common/ModalCheckField';
import { ModalCheckFamilyField } from '../common/ModalCheckMissingField';
import { PAGE_NAME } from 'constants/common';
import { toggleReviewedAndComplete } from 'services/reviewAndComplete';
import pageStatusService from 'services/pageStatusService';
import { getAccessToken, getUserId, removeAccessToken, removeUserId } from 'utils/sessionStorage';

type Props = {};

const StepParent = (props: Props) => {
  const [stateOptions, setStateOptions] = React.useState<any[]>([]);
  const [searchInput, setSearchInput] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [openMenu, setOpenMenu] = React.useState(false);
  const [selectedEducation, setSelectedEducation] = React.useState<any>();
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const [showModalCheckField, setShowModalCheckField] = React.useState(false);
  const query = new URLSearchParams(useLocation().search);
  const check = query.get('check');
  const indexExpand = query.get('index');
  let searchCtrl = new AbortController();
  const yearRetiredOptions:any = useMemo(() => optionStringValues(Array.from({ length: 70 }, (_, i) => i + 1)),[]);
  const yearAtHomeOptions:any = useMemo(() => optionStringValues(Array.from({ length: 70 }, (_, i) => i + 1)),[]);
  const yearNotEmployedOptions:any = useMemo(() => optionStringValues(Array.from({ length: 70 }, (_, i) => i + 1)),[]);
  const yearAtJobOptions:any = useMemo(() => optionStringValues(Array.from({ length: 70 }, (_, i) => i + 1)),[]);

  React.useEffect(() => {
    collegeServices.getState().then((res: any) => {
      const states = res.map((item: any) => {
        return item.descr;
      });
      setStateOptions(states);
    });
  }, []);

  const [loading, setLoading] = React.useState(true);
  const [stepParentNumber, setStepParentNumber] = React.useState('1');
  const dispatch:any = useAppDispatch();
  const history = useHistory();
  let studentId = getUserId();
  let token = getAccessToken();
  const family = useAppSelector((store) => store.family);
  const [currentParentCollege, setCurrentParentCollege] = React.useState<any[]>([]);
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const formik = useFormik({
    initialValues: {
      step_parent_is_married: '',     // varchar
      step_parent_type: '',
      step_parent_is_living: '',      // varchar
      prefix: '',
      first_name: '',
      middle_name: '',
      last_name: '',
      former_last_name: '',
      suffix: '',
      step_parent_relationship: '',
      step_parent_email: '',
      country_code: '',
      phone_number: '',
      phone_number_type: '',
      occupation: '',
      other_occupation_detail: '',
      employment_status: '',
      currently_employed_or_retire_from_college: '',
      college_or_university: {
        name: '',
        country: '',
        address_line_1: '',
        address_line_2: '',
        address_line_3: '',
        city: '',
        state: '',
        zip_code: '',
        province: '',
        state_or_province: '',
      },
      current_employer: '',
      education_level: '',

      //#region These fields will copy back from fromItem ///////////////////
      total_number_institutions_attended: '0',
      parent_graduation_college_array: [
        {
          degreesNumber: '',
          degreesReceived1: '',
          graduationYear1: '',
          degreesReceived2: '',
          graduationYear2: '',
          degreesReceived3: '',
          graduationYear3: '',
          degreesReceived4: '',
          graduationYear4: '',
          degreesReceived5: '',
          graduationYear5: '',
          school: {
            ceeb: '',
            fib_code: '',
            name: '',
            school_type: null,
            city: '',
            state: '',
            zip: '',
            country: '',
            csu_name: '',
            uc_name: '',
            cm_name: '',
            match_all: false,
            label: '',
            code: null,
            is_manual: false,
            id: '',
            // old fields :
            //   address_line_1: '',
            //   address_line_2: '',
            //   address_line_3: '',
            province: '',
            state_or_province: '',
            //   zip_code: '',
          } as any,
        },
      ],
      //#region

      college_code: '',
      college_state: '',
      college_city: '',
      date_deceased: '',
      csu_info: {
        use_chat_box: false,
        is_give_permission_communicate_to: '',
        is_give_permission_to_receive_information: '',
        authorize_parent_guardian_as_emergency_contact: '',
        isCurrentPermanentResidentOfCalifornia: '',
        isLivedInCaliforniaContinuouslySinceBirth: '',
        whenStayInCaliforniaBegin: '',
        priorCountry: '',
        priorState: '',
        fromWhenToWhenLiveThere: '',
        ToWhenToWhenLiveThere: '',
        stateRegardAsPermanentHome: '',
        parent_address_is: '',
        different_parent_address_country: '',
        different_parent_address_line_1: '',
        different_parent_address_line_2: '',
        different_parent_address_city: '',
        different_parent_address_state: '',
        different_parent_address_province: '',
        different_parent_address_zip_code: '',
        priorCountry_secondPriorResidency: '',
        priorState_secondPriorResidency: '',
        fromWhenToWhenLiveThere_secondPriorResidency: '',
        ToWhenToWhenLiveThere_secondPriorResidency: '',
        is_authorized_UC_to_share_contact_information: false,
      },
      number_of_year_at_home: '',
      number_of_year_not_employed: '',
      number_of_year_retired: '',
      step_parent_current_job_status: '',
      job_category: '',
      job_title: '',
      number_of_year_at_job: '', // varchar
    },
    onSubmit: async (values) => {
      try {
        studentId = getUserId();
        token = getAccessToken();
        if (token && studentId) {
          const newCollegeArray = formItem.values.parent_graduation_college_array.filter((item) => {
            const noSchoolId = !item?.school?.id;
            const allNull = Object.values(item).every((value) => {
              if (value && typeof value === 'object') {
                return Object.values(value).every((val) => !val);
              }
              return !value;
            });

            const notInCurrentParentCollege = !currentParentCollege.some(
              (currentItem) => currentItem?.school?.name === item?.school?.name
            );
            return noSchoolId && notInCurrentParentCollege && !allNull;
          });


          //#region remove priorCountryOption and objectCountries propeties
          let new_csu:any = Object.assign({}, values.csu_info);
          delete new_csu.priorCountryOption;
          delete new_csu.objectCountries;
          //#endregion

          const newValues = {
            ...values,
            college_or_university: JSON.stringify(values.college_or_university),
            total_number_institutions_attended: formItem.values.total_number_institutions_attended,
            parent_graduation_college_array: JSON.stringify(formItem.values.parent_graduation_college_array),
            date_deceased: formatBoolean(values.step_parent_is_living) === false ? values.date_deceased : '',
            csu_info: JSON.stringify(new_csu),
            number_of_year_at_job: `${values.number_of_year_at_job ?? '0'}`,
            student_id: parseInt(studentId || ''),
          };

          location.pathname === routers.stepParent1.path
            ? await dispatch(updateStepParent1(newValues))
            : await dispatch(updateStepParent2(newValues));

          //#region sendMailNewParentCollege
          if (newCollegeArray.length > 0 && formItem.values.is_education_saved) {
            const dataSendmail = {
              student_id: parseInt(studentId || ''),
              parent_name:
                location.pathname === routers.stepParent1.path
                  ? 'Step Parent No.1'
                  : 'Step Parent No.2',
              collegesInfo: newCollegeArray,
            };
            await collegeServices.sendMailNewParentCollege(dataSendmail);
          }
          //#endregion

        } else {
          handleLogout();
        }
      } catch (ex) {
        console.log('Error:', ex);
      }
    },
  });

  const formItem = useFormik({
    initialValues: {
      total_number_institutions_attended: '0',
      parent_graduation_college_array: [
        {
          degreesNumber: '',
          degreesReceived1: '',
          graduationYear1: '',
          degreesReceived2: '',
          graduationYear2: '',
          degreesReceived3: '',
          graduationYear3: '',
          degreesReceived4: '',
          graduationYear4: '',
          degreesReceived5: '',
          graduationYear5: '',
          school: {
            ceeb: '',
            fib_code: '',
            name: '',
            school_type: null,
            city: '',
            state: '',
            zip: '',
            country: '',
            csu_name: '',
            uc_name: '',
            cm_name: '',
            match_all: false,
            label: '',
            code: null,
            is_manual: false,
            id: '',
            // old fields :
            //   address_line_1: '',
            //   address_line_2: '',
            //   address_line_3: '',
            province: '',
            state_or_province: '',
            //   zip_code: '',
          } as any,
        },
      ],
      is_education_saved: false,
    },
    onSubmit: async (values) => {
      formik.setFieldValue('total_number_institutions_attended', values.total_number_institutions_attended);
      formik.setFieldValue('parent_graduation_college_array', values.parent_graduation_college_array);
    },
  });

  const checkCountry = () => {
    if (
      formik.values.college_or_university.country !== 'Canada' &&
      formik.values.college_or_university.country !== 'United States of America'
    ) {
      formik.setFieldValue('college_or_university.state', null);
      formik.setFieldValue('college_or_university.province', null);
      if (!formik.values.college_or_university.state_or_province) {
        formik.setFieldValue('college_or_university.state_or_province', '');
      }
    }
  };

  const location = useLocation();
  React.useEffect(() => {
    location.pathname === routers.stepParent1.path
      ? setStepParentNumber('1')
      : setStepParentNumber('2');
  }, [location]);

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const handleContinue = () => {
    const pageName = location.pathname === routers.stepParent1.path ? 'stepParent1' : 'stepParent2';
    const nextRoute = Object.keys(family.roleFamily).find(
      (key, index) =>
        index > Object.keys(family.roleFamily).indexOf(pageName) && family.roleFamily[key] === true
    );
    formik.handleSubmit();
    history.push(nextRoute ? routers?.[nextRoute]?.path : routers.enrolimentStatus.path);
  };

  const handleCheckMissingFields = () => {
    setShowModalCheckField(true);
  };

  const handleCloseModal = () => {
    setShowModalCheckField(false);
  };

  // Prepare data for modal check
  const getModalData = () => {
    return {
      ...formik.values,
      parent_graduation_college_array: formItem.values.parent_graduation_college_array,
    };
  };

  const onReviewdAndComplete = () => {
    const pageName = location.pathname === routers.stepParent1.path ? PAGE_NAME.STEP_PARENT_1 : PAGE_NAME.STEP_PARENT_2;
    void toggleReviewedAndComplete(pageName, reviewedAndComplete, setReviewedAndComplete);
  }

  // const handleChatBoxChange = async (e: any) => {
  //   const isChecked = e.target.checked;
  //   setChatBoxState(isChecked);
  //   formik.setFieldValue('csu_info.use_chat_box', isChecked);

  //   if (isChecked) {
  //     try {
  //       const email = formik.values.step_parent_email;
  //       if (email) {
  //         const emailCheck = await familyServices.checkStudentEmail(email);

  //         if (emailCheck && emailCheck.data && Object.keys(emailCheck.data).length > 0) {
  //           // Email exists, save the state
  //           setChatBoxState(true);
  //         } else {
  //           // Email doesn't exist, create parent
  //           await familyServices.createParent(studentId, {
  //             email,
  //           });
  //         }
  //       }
  //     } catch (error) {
  //       console.log('Error checking email or creating parent:', error);
  //     }
  //   }
  // };

  const getPageStatus = async (pageName: string) => {
    const pageStatus: {
      student_completed: boolean;
    } = await pageStatusService.getPageStatusByPageName(studentId, pageName);
    if(pageStatus) {
      setReviewedAndComplete(pageStatus.student_completed);
    }
  }

  const getDetail = async () => {
    try {
     const pageName = location.pathname === routers.stepParent1.path ? PAGE_NAME.STEP_PARENT_1 : PAGE_NAME.STEP_PARENT_2;
      studentId = getUserId();
      token = getAccessToken();
      if (token && studentId) {
        setLoading(true);
        await dispatch(getHousehold(studentId));
        let res = null;

        if (pageName === PAGE_NAME.STEP_PARENT_1) {
          res = await dispatch(getStepParent1(studentId));
          await getPageStatus(pageName);
        } else if (pageName === PAGE_NAME.STEP_PARENT_2) {
          res = await dispatch(getStepParent2(studentId));
          await getPageStatus(pageName);
        }

        const dataLoaded: any = res.payload;
        if (dataLoaded) {
          const college_or_university = checkEnableParseJSON(dataLoaded.college_or_university, {
            name: '',
            country: '',
            address_line_1: '',
            address_line_2: '',
            city: '',
            state: '',
            zip_code: '',
            province: '',
            state_or_province: '',
            id: '',
          });

          //#region clean up values
          if (college_or_university?.name === 'null') {
            college_or_university.name = '';
          }
          if (college_or_university?.id === 'null') {
            college_or_university.id = '';
          }
          //#endregion

          formik.resetForm({
            values: {
              ...formik.values,
              ...dataLoaded,
              csu_info: {
                ...formik.values.csu_info,
                ...checkEnableParseJSON(dataLoaded.csu_info),
              },
              total_number_institutions_attended: dataLoaded.total_number_institutions_attended?.toString(),

              college_or_university,
              parent_graduation_college_array: checkEnableParseJSON(
                dataLoaded?.parent_graduation_college_array
              ),
            },
          });

          formItem.resetForm({
            values: {
              ...formItem.values,
              total_number_institutions_attended: `${dataLoaded.total_number_institutions_attended}`,
              parent_graduation_college_array: checkEnableParseJSON(dataLoaded.parent_graduation_college_array),
            },
          });

          setSelectedEducation(college_or_university);

          if (dataLoaded.parent_graduation_college_array) {
            setCurrentParentCollege(
              checkEnableParseJSON(dataLoaded.parent_graduation_college_array)
            );
          }
        }

        // if (formik.values.csu_info?.isLivedInCaliforniaContinuouslySinceBirth !== 'false') {
        //   getContries();
        // }

        setLoading(false);
        formik.setStatus('idle');
      } else {
        handleLogout();
      }
    } catch (ex) {
      console.log('Error:', ex);
    }
  };

  // const getContries = () => {
  //   familyServices
  //     .getContriesCSU()
  //     .then((res: any) => {
  //       let csuCountryTemp: any[] = [];
  //       res.data.map((item: any) => {
  //         csuCountryTemp.push(item.name);
  //       });
  //       formik.setFieldValue('csu_info.priorCountryOptions', csuCountryTemp);
  //       formik.setFieldValue('csu_info.objectCountries', res.data);
  //     })
  //     .catch((err: any) => {
  //       return err;
  //     });
  // };

  React.useEffect(() => {
    getDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [collegeData, setCollegeData] = React.useState<any>();

  const handleGetCollege = async (keyword: string) => {
    if (keyword && keyword.trim().length>0) {
      searchCtrl.abort();
      searchCtrl = new AbortController();
      setIsLoading(true);
      const res: any = await collegeServices.getCollegeEx({ keyword: keyword.trim() }, searchCtrl);

      const data = res.map((item: any) => ({
        ...item,
        id: item.id,
        label: item.name,
        value: item.name,
      }));
      setCollegeData(data);
      setIsLoading(false);
      setOpenMenu(true);
    }
    else {
      setCollegeData([]);
    }
  };

  const handleSearchCollege = debounce((keyword: string) => {
    defer(() => {
      handleGetCollege(keyword);
    });
  }, 300);

  const handleFormChange = (e: any) => {
    checkCountry();
    formik.handleChange(e);
  };

  // Auto save function ==========
  React.useEffect(() => {
    if (location.pathname === routers.stepParent1.path) {
      if (family.stepParent1 !== null)
        if (formik.dirty && !loading) {
          debounceSaving();
        }
    } else if (location.pathname === routers.stepParent2.path) {
      if (family.stepParent2 !== null)
        if (formik.dirty && !loading) {
          debounceSaving();
        }
    }
  }, [formik.values]);
  const debounceSaving = React.useCallback(
    debounce(() => {
      formik.handleSubmit();
    }, 1500),
    []
  );

  React.useEffect(() => {
    // Handle responsive detection
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // Auto save function ==========
  return loading ? (
    <LoadingContent />
  ) : (
    <>
      <TopProcessBar
        stepProcess={[{ title: 'General', percentOnProcess: 25 }]}
        title="Family Information"
        process={1}
        icon={<PeopleAltOutlinedIcon />}
        isMobile={isMobile}
      />
      <Container 
        className={`main-container gm-basic-info-page ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '60px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden'
        }}
      >
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`}>
          <Form
            style={{ 
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%'
            }}
            onSubmit={formik.handleSubmit}
            className="gm-form-grid"
          >
            <div className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
              <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                Step Parent No. {stepParentNumber}
              </span>
            </div>
            <div className="gm-section-card">
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <GroupRadioButton
                    mdCol={6}
                    logo="span-cm-logo"
                    options={[{ value: 'Parent 1' }, { value: 'Parent 2' }]}
                    onClear={() => formik.setFieldValue('step_parent_is_married', '')}
                    label={`Step-parent ${stepParentNumber} is married to*`}
                    name="step_parent_is_married"
                    onChange={formik.handleChange}
                    values={formik.values.step_parent_is_married}
                    isMissing={!formik.values.step_parent_is_married && check}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12}>
                  <GroupRadioButton
                    mdCol={6}
                    logo="span-cm-logo"
                    label={`Step-parent ${stepParentNumber} type*`}
                    options={[{ value: 'Step-Mother' }, { value: 'Step-Father' }]}
                    name="step_parent_type"
                    values={formik.values.step_parent_type}
                    onChange={formik.handleChange}
                    isMissing={!formik.values.step_parent_type && check}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12} md={6}>
                  <YesNoSwitch
                    onClear={() => formik.setFieldValue('step_parent_is_living', '')}
                    label={`Is Step-parent ${stepParentNumber} living?*`}
                    logo="span-cm-logo"
                    name="step_parent_is_living"
                    onChange={formik.handleChange}
                    values={formik.values.step_parent_is_living}
                    isMissing={!formik.values.step_parent_is_living && check}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <ConditionalGrid xs={12} md={6} hidden={formik.values.step_parent_is_living !== 'false'}>
                  <DatePickerInput
                    label="Date deceased*"
                    name="date_deceased"
                    format="MM/yyyy"
                    values={formik.values.date_deceased}
                    onChange={(value) => formik.setFieldValue('date_deceased', value)}
                    isMissing={!formik.values.date_deceased && check}
                    disabled={reviewedAndComplete}
                  />
                </ConditionalGrid>

                <Grid xs={12} md={6}>
                  <SelectInput
                    form={formik}
                    option={[
                      { value: 'Dr.' },
                      { value: 'Mr.' },
                      { value: 'Ms.' },
                      { value: 'Mrs.' },
                    ]}
                    label="Prefix"
                    onChange={formik.handleChange}
                    name="prefix"
                    values={formik.values.prefix}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12} md={6}>
                  <TextInput
                    label="First/Given name*"
                    logo="span-cm-logo"
                    name="first_name"
                    values={formik.values.first_name}
                    onChange={formik.handleChange}
                    countText={20}
                    isMissing={!formik.values.first_name && check}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12} md={6}>
                  <TextInput
                    label="Middle Initial"
                    name="middle_name"
                    values={formik.values.middle_name}
                    onChange={formik.handleChange}
                    countText={20}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12} md={6}>
                  <TextInput
                    label="Last Name*"
                    logo="span-cm-logo"
                    name="last_name"
                    values={formik.values.last_name}
                    onChange={formik.handleChange}
                    countText={20}
                    isMissing={!formik.values.last_name && check}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12} md={6}>
                  <TextInput
                    label="Former Last Name"
                    name="former_last_name"
                    values={formik.values.former_last_name}
                    onChange={formik.handleChange}
                    countText={20}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12} md={6}>
                  <SelectInput
                    form={formik}
                    option={fullSuffixOptions}
                    label="Suffix"
                    name="suffix"
                    values={formik.values.suffix}
                    onChange={formik.handleChange}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12}>
                  <TextInput
                    label="Relationship to you*"
                    logo="span-cm-logo"
                    name="step_parent_relationship"
                    values={formik.values.step_parent_relationship}
                    onChange={formik.handleChange}
                    countText={50}
                    isMissing={!formik.values.step_parent_relationship && check}
                    disabled={reviewedAndComplete}
                  />
                </Grid>
{/* 
                <Grid xs={12}>
                  <CheckboxInput
                    setValue={(e) => handleChatBoxChange(e)}
                    label="Use chat box"
                    name="csu_info.use_chat_box"
                    values={formik.values.csu_info?.use_chat_box}
                    onChange={handleChatBoxChange}
                    disabled={reviewedAndComplete}
                  />
                </Grid> */}

                <Grid xs={12}>
                  <TextInput
                    label="Email Address *"
                    name="step_parent_email"
                    logo="span-cm-logo"
                    values={formik.values.step_parent_email}
                    onChange={formik.handleChange}
                    countText={50}
                    isMissing={!formik.values.step_parent_email && check}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12}>
                  <GroupRadioButton
                    label="Preferred phone*"
                    columns={2}
                    name="phone_number_type"
                    logo="span-cm-logo"
                    onChange={formik.handleChange}
                    values={formik.values.phone_number_type}
                    options={[
                      { value: 'Home' },
                      { value: 'Mobile' },
                      { value: 'Work' },
                      { value: 'Other' },
                    ]}
                    isMissing={!formik.values.phone_number_type && check}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12} md={3}>
                  <SelectPhoneCodeInput
                    label="Country Code"
                    logo="span-cm-logo label-14px"
                    name="country_code"
                    onChange={formik.handleChange}
                    values={formik.values.country_code}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12} md={9}>
                  <TextIconInput
                    logo="label-14px"
                    type="number*"
                    icon={<PhoneAndroidIcon />}
                    name="phone_number"
                    onChange={formik.handleChange}
                    values={formik.values.phone_number}
                    label="Phone Number*"
                    isMissing={!formik.values.phone_number && check}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12}>
                  <GroupRadioButton
                    label="Parent Address is*"
                    verticalLayout={true}
                    className="uc-flag mb-5 pt-3 "
                    name="csu_info.parent_address_is"
                    onChange={formik.handleChange}
                    values={formik.values.csu_info?.parent_address_is}
                    options={[
                      { value: 'The same as my home address', mdCol: 4 },
                      { value: 'A different address' },
                      { value: 'Unknown' },
                    ]}
                    isMissing={!formik.values.csu_info?.parent_address_is && check}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                {formik.values.csu_info?.parent_address_is === 'A different address' && (
                  <>
                    <Grid xs={12} md={6}>
                      <SelectInput
                        option={countryOptions}
                        label={'Country*'}
                        name={'csu_info.different_parent_address_country'}
                        values={formik.values.csu_info?.different_parent_address_country}
                        onChange={formik.handleChange}
                        isMissing={
                          !formik.values.csu_info?.different_parent_address_country && check
                        }
                        disabled={reviewedAndComplete}
                      />
                    </Grid>
                    <Grid xs={12} md={6}>
                      <TextInput
                        label={'Address Line 1*'}
                        name={'csu_info.different_parent_address_line_1'}
                        values={formik.values.csu_info?.different_parent_address_line_1}
                        onChange={formik.handleChange}
                        countText={36}
                        isMissing={
                          !formik.values.csu_info?.different_parent_address_line_1 && check
                        }
                        disabled={reviewedAndComplete}
                      />
                    </Grid>
                    <Grid xs={12} md={6}>
                      <TextInput
                        label={'Address Line 2'}
                        name={'csu_info.different_parent_address_line_2'}
                        values={formik.values.csu_info?.different_parent_address_line_2}
                        onChange={formik.handleChange}
                        disabled={reviewedAndComplete}
                      />
                    </Grid>
                    <Grid xs={12} md={6}>
                      <TextInput
                        label={'City*'}
                        name={'csu_info.different_parent_address_city'}
                        values={formik.values.csu_info?.different_parent_address_city}
                        onChange={formik.handleChange}
                        countText={25}
                        isMissing={!formik.values.csu_info?.different_parent_address_city && check}
                        disabled={reviewedAndComplete}
                      />
                    </Grid>
                    {formik.values.csu_info?.different_parent_address_country ===
                    'United States of America' ? (
                      <Grid xs={12} md={6}>
                        <SelectInput
                          option={stateOptions}
                          label={'State*'}
                          name={'csu_info.different_parent_address_state'}
                          values={formik.values.csu_info?.different_parent_address_state}
                          onChange={formik.handleChange}
                          isMissing={
                            !formik.values.csu_info?.different_parent_address_state && check
                          }
                          disabled={reviewedAndComplete}
                        />
                      </Grid>
                    ) : (
                      <Grid xs={12} md={6}>
                        <TextInput
                          label={'Province *'}
                          name={'csu_info.different_parent_address_province'}
                          values={formik.values.csu_info?.different_parent_address_province}
                          onChange={formik.handleChange}
                          countText={80}
                          isMissing={
                            !formik.values.csu_info?.different_parent_address_province && check
                          }
                          disabled={reviewedAndComplete}
                        />
                      </Grid>
                    )}
                    <Grid xs={12} md={6}>
                      <TextInput
                        countText={11}
                        label={'Zip Code*'}
                        name={'csu_info.different_parent_address_zip_code'}
                        values={formik.values.csu_info?.different_parent_address_zip_code}
                        onChange={formik.handleChange}
                        isMissing={!formik.values.csu_info?.different_parent_address_zip_code && check}
                        disabled={reviewedAndComplete}
                      />
                    </Grid>
                  </>
                )}

                <Grid xs={12}>
                  <div className="gm-section-title mb-4">Authorization</div>
                </Grid>

                <Grid xs={12}>
                  <YesNoSwitch
                    values={formik.values.csu_info?.is_give_permission_communicate_to}
                    onChange={formik.handleChange}
                    logo="span-csu-logo"
                    name="csu_info.is_give_permission_communicate_to"
                    label="Do you give permission for the admission office to communicate with your Parent/Guardian regarding your application?*"
                    isMissing={!formik.values.csu_info?.is_give_permission_communicate_to && check}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12}>
                  <YesNoSwitch
                    values={formik.values.csu_info?.is_give_permission_to_receive_information}
                    onChange={formik.handleChange}
                    className="py-3"
                    logo="span-csu-logo"
                    name="csu_info.is_give_permission_to_receive_information"
                    label="Do you give permission for your parent/guardian to receive university communications? These may include new student and housing information, parent activities, volunteer and charitable opportunities, and general campus information.*"
                    isMissing={
                      !formik.values.csu_info?.is_give_permission_to_receive_information && check
                    }
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12}>
                  <YesNoSwitch
                    values={formik.values.csu_info?.authorize_parent_guardian_as_emergency_contact}
                    onChange={formik.handleChange}
                    className="py-3"
                    logo="span-csu-logo"
                    name="csu_info.authorize_parent_guardian_as_emergency_contact"
                    label="I authorize the use of this parent/guardian information to be used as my emergency contact when I enroll at a CSU."
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12}>
                  <div className="px-1 py-1">
                    <div className="d-flex flex-column">
                      <label className="label-14px pb-1 span-uc-logo">
                        Can we share your parent's contact information with UC campuses and
                        programs?
                      </label>
                      <div className="py-1">
                        If you check this option, your parent may receive information about
                        admissions tips, updates and reminders from UC campuses (even ones you
                        haven't applied to) and outreach programs. They may contact them before or
                        after you've submitted the application.
                      </div>
                    </div>
                  </div>
                </Grid>

                <Grid xs={12}>
                  <CheckboxInput
                    values={formik.values.csu_info?.is_authorized_UC_to_share_contact_information}
                    onChange={formik.handleChange}
                    name="csu_info.is_authorized_UC_to_share_contact_information"
                    label="I authorize the University of California to share my parent's contact information."
                    className="py-3"
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12}>
                  <div className="gm-section-title mb-4">Employment</div>
                </Grid>

                <Grid xs={12}>
                  <GroupRadioButton
                    label="What is this parent's current job status?"
                    logo="span-uc-logo"
                    columns={2}
                    mdCol={6}
                    options={[
                      { value: 'Employed' },
                      { value: 'Stay-at-home parent/homemaker' },
                      { value: 'Not-employed' },
                      { value: 'Retired' },
                    ]}
                    name="step_parent_current_job_status"
                    values={formik.values.step_parent_current_job_status}
                    onChange={formik.handleChange}
                    disabled={reviewedAndComplete}
                    />
                </Grid>

                <Grid xs={12} md={6}>
                  <SelectInput
                    form={formik}
                    logo="span-cm-logo"
                    name="employment_status"
                    values={formik.values.employment_status}
                    option={[
                      { value: 'Employed' },
                      { value: 'Unemployed' },
                      { value: 'Retired' },
                      { value: 'Self-Employed' },
                    ]}
                    label="Employment status*"
                    onChange={formik.handleChange}
                    isCMLogo
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <ConditionalGrid xs={12} md={6} hidden={formik.values.step_parent_current_job_status !== 'Employed'}>
                  <TextInput
                    label="Current Employer"
                    name="current_employer"
                    countText={40}
                    values={formik.values.current_employer}
                    onChange={formik.handleChange}
                    disabled={reviewedAndComplete}
                  />
                </ConditionalGrid>

                {formik.values.step_parent_current_job_status ===
                  'Stay-at-home parent/homemaker' && (
                  <Grid xs={12} md={6}>
                    <SelectInput
                      option={yearAtHomeOptions}
                      label="How many years has this parent been a stay-at-home parent?"
                      logo="span-uc-logo"
                      isCMLogo
                      name="number_of_year_at_home"
                      values={formik.values.number_of_year_at_home}
                      onChange={formik.handleChange}
                      disabled={reviewedAndComplete}
                    />
                  </Grid>
                )}
                {formik.values.step_parent_current_job_status === 'Not-employed' && (
                  <Grid xs={12} md={6}>
                    <SelectInput
                      option={yearNotEmployedOptions}
                      label="How many years has this parent not been employed?"
                      logo="span-uc-logo"
                      isCMLogo
                      name="number_of_year_not_employed"
                      values={formik.values.number_of_year_not_employed}
                      onChange={formik.handleChange}
                      disabled={reviewedAndComplete}
                    />
                  </Grid>
                )}
                {formik.values.step_parent_current_job_status === 'Retired' && (
                  <Grid xs={12} md={6}>
                    <SelectInput
                      option={yearRetiredOptions}
                      label="How many years has this parent been retired?"
                      logo="span-uc-logo"
                      isCMLogo
                      name="number_of_year_retired"
                      values={formik.values.number_of_year_retired}
                      onChange={formik.handleChange}
                      disabled={reviewedAndComplete}
                    />
                  </Grid>
                )}

                <Grid xs={12} className="flex-row">
                  <div className="text-dart mt-3 d-flex align-items-center">
                    Most recent/Former job held by this parent info:
                    <span className="uc-logo ml-2"></span>
                  </div>
                </Grid>

                <Grid xs={12} md={6}>
                  <SelectInput
                    form={formik}
                    option={occupationOptions}
                    label="Occupation (former occupation, if retired or deceased)"
                    name="occupation"
                    isCMLogo
                    logo="span-cm-logo"
                    values={formik.values.occupation}
                    onChange={formik.handleChange}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <ConditionalGrid xs={12} md={6} hidden={formik.values.occupation !== 'Other'}>
                  <TextInput
                    label="Other Occupation Details"
                    logo="span-cm-logo"
                    isCMLogo
                    name="other_occupation_detail"
                    values={formik.values.other_occupation_detail}
                    onChange={formik.handleChange}
                    countText={50}
                    disabled={reviewedAndComplete}
                  />
                </ConditionalGrid>

                <Grid xs={12} md={6}>
                  <SelectInput
                    // logo="span-uc-logo"
                    label="Job Category"
                    isCMLogo
                    name="job_category"
                    values={formik.values.job_category}
                    onChange={formik.handleChange}
                    option={jobCategory}
                  />
                </Grid>

                <Grid xs={12} md={6}>
                  <TextInput
                    label="Job title"
                    countText={20}
                    name="job_title"
                    values={formik.values.job_title}
                    onChange={formik.handleChange}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12} md={6}>
                  <SelectInput
                    option={yearAtJobOptions}
                    // logo="span-uc-logo"
                    label="Number of years at job"
                    name="number_of_year_at_job"
                    isCMLogo
                    values={formik.values.number_of_year_at_job}
                    onChange={formik.handleChange}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <ConditionalGrid 
                  xs={12} 
                  hidden={
                    formik.values.step_parent_current_job_status !== 'Employed' &&
                    formik.values.step_parent_current_job_status !== 'Retired'
                  }
                >
                  <GroupRadioButton
                    logo="span-cm-logo form-label"
                    label="Is parent currently employed by or retired from a college or university?*"
                    name="currently_employed_or_retire_from_college"
                    values={formik.values.currently_employed_or_retire_from_college}
                    onChange={formik.handleChange}
                    mdCol={12}
                    verticalLayout={true}
                    options={[
                      { value: 'Never employed at a college/university' },
                      { value: 'Currently employed at a college/university' },
                      { value: 'Retired from a college/university' },
                    ]}
                    isMissing={!formik.values.currently_employed_or_retire_from_college && check}
                    disabled={reviewedAndComplete}
                  />
                </ConditionalGrid>

                {[
                  'Currently employed at a college/university',
                  'Retired from a college/university',
                ].includes(formik.values.currently_employed_or_retire_from_college) && (
                  <Grid xs={12} md={6}>
                    <TextIconInput
                      label="College/University employer lookup*"
                      logo="span-cm-logo"
                      icon={<SearchIcon />}
                      onChange={(e: any) => {
                        setSearchInput(e.target.value);
                        handleSearchCollege(e.target.value);
                        // formik.setFieldValue('college_or_university.name', e.target.value);
                      }}
                      values={searchInput}
                      isMissing={!formik.values.college_or_university?.name && check}
                      disabled={reviewedAndComplete}
                    />
                  </Grid>
                )}
                {isLoading && <LoadingContent />}
                {collegeData !== undefined &&
                  !collegeData?.length &&
                  !isLoading &&
                  !formik.values.college_or_university?.name && (
                    <Grid xs={12}>
                      <div className="text-center">Not found college</div>
                    </Grid>
                  )}

                {openMenu && collegeData &&
                  (collegeData || []).map(
                    (
                      college: {
                        label:
                          | boolean
                          | React.ReactChild
                          | React.ReactFragment
                          | React.ReactPortal
                          | null
                          | undefined;
                        address_line_1:
                          | boolean
                          | React.ReactChild
                          | React.ReactFragment
                          | React.ReactPortal
                          | null
                          | undefined;
                      },
                      index: React.Key | null | undefined
                    ) =>
                      college?.label ? (
                        <Grid xs={12} key={index}>
                          <Card className="border rounded pt-2 pb-1">
                            <div className="d-flex align-items-end position-relative">
                              <div className="mx-3 pb-2 ">{college.label}</div>
                              <div className="text-field-light sized70 pb-2">
                                {college.address_line_1}
                              </div>
                              <span className="position-absolute h-100 d-flex align-items-center end-0">
                                <AddIcon
                                  fontSize="small"
                                  className={`bg-app text-primary rounded-circle mx-3 ${reviewedAndComplete ? 'disabled-icon' : 'pointer'}`}
                                  onClick={reviewedAndComplete ? undefined : () => {
                                    setSelectedEducation(college);
                                    formik.setFieldValue('college_or_university', college);
                                    setOpenMenu(false);
                                    setSearchInput('');
                                  }}
                                  style={{
                                    opacity: reviewedAndComplete ? 0.5 : 1,
                                    cursor: reviewedAndComplete ? 'not-allowed' : 'pointer'
                                  }}
                                />
                              </span>
                            </div>
                          </Card>
                        </Grid>
                      ) : null
                  )}

                {selectedEducation?.id ? (
                  <>
                    <Grid xs={12}>
                      <div className="my-2 text-field-light">Employer Graduation College</div>
                      <div className="d-flex align-items-end position-relative">
                        <div
                          className="mx-3 pb-2 fw-bold"
                          style={{
                            color: '#4d88f0',
                          }}
                        >
                          {selectedEducation?.name}
                        </div>
                        <div className="text-field-light sized70  pb-2">
                          {selectedEducation?.address_line_1}
                        </div>
                        <span className="position-absolute h-100 d-flex align-items-center end-0">
                          <RemoveIcon
                            fontSize="small"
                            className={`bg-light text-dart rounded-circle mx-4 ${reviewedAndComplete ? 'disabled-icon' : 'pointer'}`}
                            onClick={reviewedAndComplete ? undefined : () => {
                              setSelectedEducation(undefined);
                              formik.setFieldValue('college_or_university', null);
                            }}
                            style={{
                              opacity: reviewedAndComplete ? 0.5 : 1,
                              cursor: reviewedAndComplete ? 'not-allowed' : 'pointer'
                            }}
                          />
                        </span>
                      </div>
                    </Grid>
                  </>
                ) : (collegeData !== undefined && !collegeData?.length) ||
                  selectedEducation?.name ? (
                  <>
                  <Grid xs={12}>
                    <div className="my-2 text-field-light">Employer Graduation College</div>
                  </Grid>
                  <Grid xs={12}>
                    <Grid container spacing={3} className="bg-white rounded p-3">
                      <Grid xs={12} md={6}>
                        <TextInput
                          name={'college_or_university.name'}
                          values={formik.values?.college_or_university?.name}
                          onChange={handleFormChange}
                          label="Name of college/university*"
                          countText={60}
                          isMissing={!formik.values?.college_or_university?.name && check}
                          disabled={reviewedAndComplete}
                        />
                      </Grid>

                      <Grid xs={12} md={6}>
                        <AutocompleteInput
                          name={'college_or_university.country'}
                          form={formik}
                          values={formik.values?.college_or_university?.country}
                          label="Country/Region/Territory*"
                          option={csuCountry}
                          isMissing={!formik.values?.college_or_university?.country && check}
                          onChange={(e: any) => {
                            if (
                              formik.values?.college_or_university?.country !== 'Canada' &&
                              formik.values?.college_or_university?.country !== 'United States of America'
                            ) {
                              formik.setFieldValue('college_or_university.state', null);
                              formik.setFieldValue('college_or_university.province', null);
                              if (!formik.values?.college_or_university?.state_or_province) {
                                formik.setFieldValue('college_or_university.state_or_province','');
                              }
                            }
                          }}
                          disabled={reviewedAndComplete}
                        />
                      </Grid>

                      <Grid xs={12}>
                        <TextInput
                          name={'college_or_university.address_line_1'}
                          values={formik.values?.college_or_university?.address_line_1}
                          onChange={handleFormChange}
                          label="Address Line 1"
                          countText={60}
                          disabled={reviewedAndComplete}
                        />
                      </Grid>

                      <Grid xs={12}>
                        <TextInput
                          name={'college_or_university.address_line_2'}
                          values={formik.values?.college_or_university?.address_line_2}
                          onChange={handleFormChange}
                          label="Address Line 2"
                          countText={60}
                          disabled={reviewedAndComplete}
                        />
                      </Grid>

                      <Grid xs={12}>
                        <TextInput
                          name={'college_or_university.address_line_3'}
                          values={formik.values?.college_or_university?.address_line_3}
                          onChange={handleFormChange}
                          label="Address Line 3"
                          countText={60}
                          disabled={reviewedAndComplete}
                        />
                      </Grid>

                      <Grid xs={12} md={6}>
                        <TextInput
                          name={'college_or_university.city'}
                          values={formik.values?.college_or_university?.city}
                          onChange={handleFormChange}
                          label="City"
                          countText={30}
                          disabled={reviewedAndComplete}
                        />
                      </Grid>

                      <ConditionalGrid 
                        xs={12} 
                        md={6}
                        hidden={
                          formik.values?.college_or_university?.country !==
                          'United States of America'
                        }
                      >
                        <AutocompleteInput
                          option={usaState}
                          form={formik}
                          label="State*"
                          name={'college_or_university.state'}
                          values={formik.values?.college_or_university?.state}
                          isMissing={!formik.values?.college_or_university?.state && check}
                          disabled={reviewedAndComplete}
                        />
                      </ConditionalGrid>

                      <ConditionalGrid 
                        xs={12} 
                        md={6}
                        hidden={formik.values?.college_or_university?.country !== 'Canada'}
                      >
                        <AutocompleteInput
                          form={formik}
                          option={canadaProvince}
                          label="Province*"
                          name={'college_or_university.province'}
                          values={formik.values?.college_or_university?.province}
                          isMissing={!formik.values?.college_or_university?.province && check}
                          disabled={reviewedAndComplete}
                        />
                      </ConditionalGrid>

                      <ConditionalGrid 
                        xs={12} 
                        md={6}
                        hidden={
                          formik.values?.college_or_university?.country === 'Canada' ||
                          formik.values?.college_or_university?.country ===
                            'United States of America'
                        }
                      >
                        <TextInput
                          name={'college_or_university.state_or_province'}
                          values={formik.values?.college_or_university?.state_or_province}
                          onChange={(e: any) => {
                            formik.setFieldValue('college_or_university.state', null);
                            formik.setFieldValue('college_or_university.province', null);
                            formik.setFieldValue(
                              'college_or_university.state_or_province',
                              e.target.value
                            );
                            handleFormChange(e);
                          }}
                          label="State or Province"
                          countText={30}
                          disabled={reviewedAndComplete}
                        />
                      </ConditionalGrid>

                      <Grid xs={12} md={6}>
                        <TextInput
                          name={'college_or_university.zip_code'}
                          values={formik.values?.college_or_university?.zip_code}
                          onChange={handleFormChange}
                          label="Zip Code*"
                          countText={10}
                          isMissing={!formik.values?.college_or_university?.zip_code && check}
                          disabled={reviewedAndComplete}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  </>
                ) : null}
              </Grid>
            </div>
            <div className="gm-section-card">
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <div id="Education" className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
                    <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                      Education
                    </span>
                  </div>
                </Grid>
                <Education
                  formik={formik}
                  isMobile={isMobile}
                  formItem={formItem}
                  check={check}
                  indexExpand={indexExpand}
                  disabled={reviewedAndComplete}
                />
              </Grid>
            </div>

            <div className="gm-section-card">
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <div id="Residency" className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
                    <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                      Residency
                    </span>
                  </div>
                </Grid>
                <Residency formik={formik} check={check} isMobile={isMobile} disabled={reviewedAndComplete} />
              </Grid>
            </div>

            <div className={`gm-form-actions border-top ${isMobile ? 'pt-2 mt-3' : 'pt-3 mt-4'} d-flex ${isMobile ? 'flex-column' : 'justify-content-between align-items-center'}`}>
              {/* Icon + Checkbox combo on the left */}
              <div className={`${isMobile ? 'w-100 mb-3' : ''} d-flex justify-content-center`}>
                <div className="d-flex flex-column align-items-center">
                  <div
                    onClick={handleCheckMissingFields}
                    className="d-flex align-items-center cursor-pointer mb-2"
                  >
                    <SearchIcon
                      style={{
                        fontSize: '24px',
                        color: '#6c757d',
                      }}
                    />
                    <span
                      style={{
                        fontSize: '14px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      check missing values
                    </span>
                  </div>

                  <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                    <input
                      type="checkbox"
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid #6c757d',
                        borderRadius: '2px',
                      }}
                      checked={reviewedAndComplete}
                      onClick={onReviewdAndComplete}  
                    />
                    <span
                      style={{
                        fontSize: isMobile ? '14px' : '12px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      Reviewed
                    </span>
                  </div>
                </div>
              </div>

              {/* Save and Continue buttons on the right */}
              <div className={`${isMobile ? 'w-100' : 'col col-md-6'} text-center ${isMobile ? '' : 'text-md-end'}`}>
                <div className={`d-flex ${isMobile ? 'flex-column gap-2' : 'flex-row'} justify-content-center`}>
                  <Button 
                    variant="primary" 
                    type="submit" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5 mx-2'} gm-btn-save`}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    {family.status === 'loading' ? (
                      <Spinner size="sm" animation="border" variant="light" />
                    ) : (
                      'Save'
                    )}
                  </Button>
                  <Button
                    variant="primary"
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} gm-btn-continue`}
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Container>

      <ModalCheckFamilyField
        show={showModalCheckField}
        onClose={handleCloseModal}
        data={getModalData()}
        page={`step-parent-${stepParentNumber}`}
      />
    </>
  );
};

export default StepParent;
